import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';
import notFound_404_Icon from '../../../assets/images/not_found_404_icon.svg';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className='min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50 text-center'>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        // className="bg-white shadow-lg rounded-2xl p-10"
      >
        <div className='flex justify-center items-center'>
          <img
            src={notFound_404_Icon}
            alt='Empty cart'
            className=' 
                        mb-6
                        min-h-[8rem] max-h-[8rem] min-w-30 max-w-50 
                        sm:min-h-[8rem] sm:max-h-[8rem] sm:min-w-30 sm:max-w-50  
                        md:min-h-[10rem] md:max-h-[10rem] md:min-w-30 md:max-w-[30rem]
                        lg:min-h-[10rem] lg:max-h-[10rem] lg:min-w-30 lg:max-w-[30rem]'
          />
        </div>

        <h2 className='text-3xl text-[#552B18] mb-2 font-rubik'>Page Not Found</h2>
        <p className='text-[#9E9E9E] mb-6 font-medium font-poppins text-base'>
          Oops! The page you’re looking for doesn’t exist or may have been moved.
        </p>
        <div className='flex justify-center items-center'>
          <button
            onClick={handleGoBack}
            className='font-rubik flex items-center justify-center gap-2 bg-[#C12E2A] hover:bg-[#a32622] text-white px-16 py-3 rounded-xl font-medium transition text-lg'
          >
            <ArrowLeft size={22} /> Go Back
          </button>
        </div>
      </motion.div>
    </div>
  );
}
